import { useEffect, useState } from "react";
import { _CreditProcessMovement } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    idCompany: number
}

export const SelectPayrollFactor = ({ idCompany, idSelector, onChange, label }: Props) => {

    const { instance, setLista, lista } = useDataBean(_CreditProcessMovement)
    const [id, setID] = useState(idSelector);

    useEffect(() => {
        if (idCompany) {
            getLista();
        } else {
            setLista([])
        }
    }, [idCompany])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getLista = () => {
        instance.getLoanLinePayrollFactorList(idCompany).then(
            (resp: any) => {
                setLista(resp)
                if (resp.length === 1) {
                    setID(resp[0].DataBeanProperties.IDPayrollFactor)
                    onChange(resp[0].DataBeanProperties.IDPayrollFactor)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Payroll a Aplicar"}</label>
            <select name="payroll" className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""} >...</option>
                {lista.map((item: any) => {
                    return (
                        <option key={item.DataBeanProperties.IDPayrollFactor} value={item.DataBeanProperties.IDPayrollFactor}>{item.DataBeanProperties.Name}</option>
                    )
                })}
            </select>
        </>
    )
}